"use strict";

var _toConsumableArray = require("/home/circleci/neene-player/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
var _classCallCheck = require("/home/circleci/neene-player/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/home/circleci/neene-player/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToWords = exports.DefaultToWordsOptions = exports.DefaultConverterOptions = void 0;
var en_AE_1 = __importDefault(require("./locales/en-AE"));
var en_BD_1 = __importDefault(require("./locales/en-BD"));
var en_GH_1 = __importDefault(require("./locales/en-GH"));
var en_IN_1 = __importDefault(require("./locales/en-IN"));
var en_MM_1 = __importDefault(require("./locales/en-MM"));
var en_MU_1 = __importDefault(require("./locales/en-MU"));
var en_NG_1 = __importDefault(require("./locales/en-NG"));
var en_NP_1 = __importDefault(require("./locales/en-NP"));
var en_US_1 = __importDefault(require("./locales/en-US"));
var en_GB_1 = __importDefault(require("./locales/en-GB"));
var en_PH_1 = __importDefault(require("./locales/en-PH"));
var fa_IR_1 = __importDefault(require("./locales/fa-IR"));
var fr_BE_1 = __importDefault(require("./locales/fr-BE"));
var fr_FR_1 = __importDefault(require("./locales/fr-FR"));
var gu_IN_1 = __importDefault(require("./locales/gu-IN"));
var hi_IN_1 = __importDefault(require("./locales/hi-IN"));
var mr_IN_1 = __importDefault(require("./locales/mr-IN"));
var pt_BR_1 = __importDefault(require("./locales/pt-BR"));
var tr_TR_1 = __importDefault(require("./locales/tr-TR"));
var nl_SR_1 = __importDefault(require("./locales/nl-SR"));
var ee_EE_1 = __importDefault(require("./locales/ee-EE"));
exports.DefaultConverterOptions = {
  currency: false,
  ignoreDecimal: false,
  ignoreZeroCurrency: false,
  doNotAddOnly: false
};
exports.DefaultToWordsOptions = {
  localeCode: 'en-IN',
  converterOptions: exports.DefaultConverterOptions
};
var ToWords = /*#__PURE__*/function () {
  function ToWords() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, ToWords);
    this.options = {};
    this.locale = undefined;
    this.options = Object.assign({}, exports.DefaultToWordsOptions, options);
  }
  _createClass(ToWords, [{
    key: "getLocaleClass",
    value: function getLocaleClass() {
      /* eslint-disable @typescript-eslint/no-var-requires */
      switch (this.options.localeCode) {
        case 'ee-EE':
          return ee_EE_1.default;
        case 'en-AE':
          return en_AE_1.default;
        case 'en-BD':
          return en_BD_1.default;
        case 'en-GH':
          return en_GH_1.default;
        case 'en-IN':
          return en_IN_1.default;
        case 'en-MM':
          return en_MM_1.default;
        case 'en-MU':
          return en_MU_1.default;
        case 'en-NG':
          return en_NG_1.default;
        case 'en-NP':
          return en_NP_1.default;
        case 'en-US':
          return en_US_1.default;
        case 'en-GB':
          return en_GB_1.default;
        case 'en-PH':
          return en_PH_1.default;
        case 'fa-IR':
          return fa_IR_1.default;
        case 'fr-BE':
          return fr_BE_1.default;
        case 'fr-FR':
          return fr_FR_1.default;
        case 'gu-IN':
          return gu_IN_1.default;
        case 'hi-IN':
          return hi_IN_1.default;
        case 'mr-IN':
          return mr_IN_1.default;
        case 'pt-BR':
          return pt_BR_1.default;
        case 'tr-TR':
          return tr_TR_1.default;
        case 'nl-SR':
          return nl_SR_1.default;
      }
      /* eslint-enable @typescript-eslint/no-var-requires */
      throw new Error("Unknown Locale \"".concat(this.options.localeCode, "\""));
    }
  }, {
    key: "getLocale",
    value: function getLocale() {
      if (this.locale === undefined) {
        var LocaleClass = this.getLocaleClass();
        this.locale = new LocaleClass();
      }
      return this.locale;
    }
  }, {
    key: "convert",
    value: function convert(number) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      options = Object.assign({}, this.options.converterOptions, options);
      if (!this.isValidNumber(number)) {
        throw new Error("Invalid Number \"".concat(number, "\""));
      }
      if (options.ignoreDecimal) {
        number = Number.parseInt(number.toString());
      }
      var words = [];
      if (options.currency) {
        words = this.convertCurrency(number, options);
      } else {
        words = this.convertNumber(number);
      }
      return words.join(' ');
    }
  }, {
    key: "convertNumber",
    value: function convertNumber(number) {
      var _words;
      var _a, _b, _c;
      var locale = this.getLocale();
      var isNegativeNumber = number < 0;
      if (isNegativeNumber) {
        number = Math.abs(number);
      }
      var split = number.toString().split('.');
      var ignoreZero = this.isNumberZero(number) && locale.config.ignoreZeroInDecimals;
      var words = this.convertInternal(Number(split[0]));
      var isFloat = this.isFloat(number);
      if (isFloat && ignoreZero) {
        words = [];
      }
      var wordsWithDecimal = [];
      if (isFloat) {
        if (!ignoreZero) {
          wordsWithDecimal.push(locale.config.texts.point);
        }
        if (split[1].startsWith('0') && !((_a = locale.config) === null || _a === void 0 ? void 0 : _a.decimalLengthWordMapping)) {
          var zeroWords = [];
          var _iterator = _createForOfIteratorHelper(split[1]),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var num = _step.value;
              zeroWords.push.apply(zeroWords, _toConsumableArray(this.convertInternal(Number(num))));
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
          wordsWithDecimal.push.apply(wordsWithDecimal, zeroWords);
        } else {
          wordsWithDecimal.push.apply(wordsWithDecimal, _toConsumableArray(this.convertInternal(Number(split[1]))));
          var decimalLengthWord = (_c = (_b = locale.config) === null || _b === void 0 ? void 0 : _b.decimalLengthWordMapping) === null || _c === void 0 ? void 0 : _c[split[1].length];
          if (decimalLengthWord) {
            wordsWithDecimal.push(decimalLengthWord);
          }
        }
      }
      var isEmpty = words.length <= 0;
      if (!isEmpty && isNegativeNumber) {
        words.unshift(locale.config.texts.minus);
      }
      (_words = words).push.apply(_words, wordsWithDecimal);
      return words;
    }
  }, {
    key: "convertCurrency",
    value: function convertCurrency(number) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var _a, _b, _c, _d;
      var locale = this.getLocale();
      var currencyOptions = (_a = options.currencyOptions) !== null && _a !== void 0 ? _a : locale.config.currency;
      var isNegativeNumber = number < 0;
      if (isNegativeNumber) {
        number = Math.abs(number);
      }
      number = this.toFixed(number);
      // Extra check for isFloat to overcome 1.999 rounding off to 2
      var split = number.toString().split('.');
      var words = _toConsumableArray(this.convertInternal(Number(split[0])));
      if (currencyOptions.plural) {
        words.push(currencyOptions.plural);
      }
      var ignoreZero = this.isNumberZero(number) && (options.ignoreZeroCurrency || ((_b = locale.config) === null || _b === void 0 ? void 0 : _b.ignoreZeroInDecimals) && number !== 0);
      if (ignoreZero) {
        words = [];
      }
      var wordsWithDecimal = [];
      var isFloat = this.isFloat(number);
      if (isFloat) {
        if (!ignoreZero) {
          wordsWithDecimal.push(locale.config.texts.and);
        }
        wordsWithDecimal.push.apply(wordsWithDecimal, _toConsumableArray(this.convertInternal(Number(split[1]) * (!locale.config.decimalLengthWordMapping ? Math.pow(10, 2 - split[1].length) : 1))));
        var decimalLengthWord = (_d = (_c = locale.config) === null || _c === void 0 ? void 0 : _c.decimalLengthWordMapping) === null || _d === void 0 ? void 0 : _d[split[1].length];
        if (decimalLengthWord === null || decimalLengthWord === void 0 ? void 0 : decimalLengthWord.length) {
          wordsWithDecimal.push(decimalLengthWord);
        }
        wordsWithDecimal.push(currencyOptions.fractionalUnit.plural);
      } else if (locale.config.decimalLengthWordMapping && words.length) {
        wordsWithDecimal.push(currencyOptions.fractionalUnit.plural);
      }
      var isEmpty = words.length <= 0 && wordsWithDecimal.length <= 0;
      if (!isEmpty && isNegativeNumber) {
        words.unshift(locale.config.texts.minus);
      }
      if (!isEmpty && locale.config.texts.only && !options.doNotAddOnly && !locale.config.onlyInFront) {
        wordsWithDecimal.push(locale.config.texts.only);
      }
      if (wordsWithDecimal.length) {
        var _words2;
        (_words2 = words).push.apply(_words2, wordsWithDecimal);
      }
      if (!isEmpty && !options.doNotAddOnly && locale.config.onlyInFront) {
        words.splice(0, 0, locale.config.texts.only);
      }
      return words;
    }
  }, {
    key: "convertInternal",
    value: function convertInternal(number) {
      var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
      var locale = this.getLocale();
      if (locale.config.exactWordsMapping) {
        var exactMatch = (_b = (_a = locale.config) === null || _a === void 0 ? void 0 : _a.exactWordsMapping) === null || _b === void 0 ? void 0 : _b.find(function (elem) {
          return number === elem.number;
        });
        if (exactMatch) {
          return [exactMatch.value];
        }
      }
      var match = locale.config.numberWordsMapping.find(function (elem) {
        return number >= elem.number;
      });
      var words = [];
      if (number <= 100 || number < 1000 && locale.config.namedLessThan1000) {
        words.push(match.value);
        number -= match.number;
        if (number > 0) {
          if ((_d = (_c = locale.config) === null || _c === void 0 ? void 0 : _c.splitWord) === null || _d === void 0 ? void 0 : _d.length) {
            words.push(locale.config.splitWord);
          }
          words.push.apply(words, _toConsumableArray(this.convertInternal(number)));
        }
        return words;
      }
      var quotient = Math.floor(number / match.number);
      var remainder = number % match.number;
      var matchValue = match.value;
      if (quotient > 1 && ((_f = (_e = locale.config) === null || _e === void 0 ? void 0 : _e.pluralWords) === null || _f === void 0 ? void 0 : _f.find(function (word) {
        return word === match.value;
      })) && ((_g = locale.config) === null || _g === void 0 ? void 0 : _g.pluralMark)) {
        matchValue += locale.config.pluralMark;
      }
      if (quotient === 1 && ((_j = (_h = locale.config) === null || _h === void 0 ? void 0 : _h.ignoreOneForWords) === null || _j === void 0 ? void 0 : _j.includes(matchValue))) {
        words.push(matchValue);
      } else {
        words.push.apply(words, _toConsumableArray(this.convertInternal(quotient)).concat([matchValue]));
      }
      if (remainder > 0) {
        if ((_l = (_k = locale.config) === null || _k === void 0 ? void 0 : _k.splitWord) === null || _l === void 0 ? void 0 : _l.length) {
          if (!((_o = (_m = locale.config) === null || _m === void 0 ? void 0 : _m.noSplitWordAfter) === null || _o === void 0 ? void 0 : _o.find(function (word) {
            return word === match.value;
          }))) {
            words.push(locale.config.splitWord);
          }
        }
        words.push.apply(words, _toConsumableArray(this.convertInternal(remainder)));
      }
      return words;
    }
  }, {
    key: "toFixed",
    value: function toFixed(number) {
      var precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
      return Number(Number(number).toFixed(precision));
    }
  }, {
    key: "isFloat",
    value: function isFloat(number) {
      return Number(number) === number && number % 1 !== 0;
    }
  }, {
    key: "isValidNumber",
    value: function isValidNumber(number) {
      return !isNaN(parseFloat(number)) && isFinite(number);
    }
  }, {
    key: "isNumberZero",
    value: function isNumberZero(number) {
      return number >= 0 && number < 1;
    }
  }]);
  return ToWords;
}();
exports.ToWords = ToWords;